module.exports = __webpack_public_path__ + "static/media/almondsheabutter.feb81fca.jpeg";